import { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Common Components
import Header from './components/Header';
import HeroSection from './components/Herosection';
import About from './components/About';
import Service from './components/Service';
import Sector from './components/Sector';
import Footer from './components/Footer';
import Aboutpg from './components/Aboutpg';
import ContactPage from './components/Contactpage';
import Contacthero from './components/Contacthero';
import Webdesign from './components/Webdesign';
import Webservice from './components/Webservice';
import Manpower from './components/Manpower';
import Manpowerservice from './components/Manpowerservice';
import Gst from './components/Gst';
import Gstservice from './components/Gstservice';

import Loader from './components/Loader'; // 👈 Import your loader

function Home() {
  return (
    <>
      <Header />
      <HeroSection />
      <Sector />
      <Service />
      <Footer />
    </>
  );
}

function Abouts() {
  return (
    <>
      <Header />
      <Aboutpg />
      <About />
      <Footer />
    </>
  );
}

function WebPage() {
  return (
    <>
      <Header />
      <Webdesign />
      <Webservice />
      <Footer />
    </>
  );
}

function Manpowerpage() {
  return (
    <>
      <Header />
      <Manpower />
      <Manpowerservice />
      <Footer />
    </>
  );
}

function Gstpage() {
  return (
    <>
      <Header />
      <Gst />
      <Gstservice />
      <Footer />
    </>
  );
}

function ContactPg() {
  return (
    <>
      <Header />
      <ContactPage />
      <Contacthero />
      <Footer />
    </>
  );
}

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate loading time
    const timer = setTimeout(() => setLoading(false), 1500);
    return () => clearTimeout(timer);
  }, []);

  return loading ? (
    <Loader />
  ) : (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/aboutus" element={<Abouts />} />
        <Route path="/servicepg" element={<WebPage />} />
        <Route path="/contactpg" element={<ContactPg />} />
        <Route path="/manpowerpg" element={<Manpowerpage />} />
        <Route path="/gstpg" element={<Gstpage />} />
      </Routes>
    </Router>
  );
}

export default App;
